/**
 * پذیرشِ مجددِ سند وقتی نسخه‌اش بالا رفته — قرینه‌ی
 * apps/mobile/app/accept-terms.tsx.
 *
 * چرا یک صفحه‌ی تمام‌قد و نه یک نوارِ بالای صفحه: بند ۲۱ سند قول داده که
 * تغییرِ بااهمیت «پیش از اجرایی شدن» به اطلاع کاربر می‌رسد و پذیرشِ مجدد
 * درخواست می‌شود. نواری که بشود نادیده‌اش گرفت این را برآورده نمی‌کند.
 *
 * متن **کاملِ** سند همین‌جاست، نه یک لینک به جایی دیگر: چیزی که کاربر
 * می‌پذیرد باید همان چیزی باشد که جلوی چشمش است.
 */
import React, { useState } from 'react';
import { useMutation } from '@tanstack/react-query';
import { profileRepo } from '@/core/data/socialRepo';
import { useSession } from '@/core/session';
import { getLocale, t, useLocale } from '@/core/lib/i18n';
import { legalDoc } from '@/core/legal/terms';
import { reportError } from '@/core/lib/report';
import { Note } from '@/ui/kit';

export function AcceptTermsPage() {
  useLocale();
  const { refreshProfile } = useSession();
  const doc = legalDoc(getLocale());
  const [error, setError] = useState<string | null>(null);

  const accept = useMutation({
    mutationFn: () => profileRepo.acceptCurrentTerms(),
    // شرطِ گیت از `profile` می‌خواند، پس تازه‌سازیِ نشست همان چیزی است که
    // صفحه را می‌بندد — هیچ ناوبریِ دستی‌ای لازم نیست.
    onSuccess: () => { void refreshProfile(); },
    onError: (e) => { reportError('web.terms.accept', e); setError(t('errorRetry')); },
  });

  return (
    <div className="wrap prose">
      <h1>{t('termsUpdatedTitle')}</h1>
      <Note tone="warn">{t('termsUpdatedBody')}</Note>
      <p className="dim">{doc.updated}</p>
      <p>{doc.intro}</p>
      {doc.sections.map((s) => (
        <section key={s.n}>
          <h3>{s.n}. {s.title}</h3>
          {s.body.map((line, i) => <p key={i}>{line}</p>)}
        </section>
      ))}
      {error ? <p className="error">{error}</p> : null}
      <button type="button" className="btn block" data-testid="accept-terms"
        disabled={accept.isPending} onClick={() => accept.mutate()}>
        {t('termsAccept')}
      </button>
    </div>
  );
}
